import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pay-checked",
  "use": "icon-pay-checked-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-pay-checked\"><defs><style>#icon-pay-checked .a{fill:#c5aa7b;}#icon-pay-checked .b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g transform=\"translate(-237 -477)\"><circle class=\"a\" cx=\"10\" cy=\"10\" r=\"10\" transform=\"translate(237 477)\" /><path class=\"b\" d=\"M4328.382,541.825l4.2,4.545,6.721-7.707\" transform=\"translate(-4086.843 -55)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pay-checked.svg
// module id = YHEL
// module chunks = 68